<template>
  <filter-groupings-expand-toggle v-bind="$attrs" :cache-key="cacheKey" />
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.schedule && isMyPrograms"
    :title="checkboxFilters.schedule.label"
    icon="calendar_month"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.scheduleFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['schedule'] })"
    container-classes="schedule"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.schedule"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.fb"
    :title="checkboxFilters.fb.label"
    icon="dashboard"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.fbCollectionFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['fb'] })"
    container-classes="fb-collections"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.fb"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.picktime"
    :title="checkboxFilters.picktime.label"
    icon="timer"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.pickTimeFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['picktime'] })"
    container-classes="membership"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.picktime"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.specialtyprogram"
    :title="checkboxFilters.specialtyprogram.label"
    icon="list_alt"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.specialtyProgramsFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['specialtyprogram'] })"
    container-classes="specialty-program"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.specialtyprogram"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.difficulty"
    :title="checkboxFilters.difficulty.label"
    icon="local_fire_department"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.difficultyFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['difficulty'] })"
    container-classes="difficulty"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.difficulty"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useSearchFilter } from '@/composables/search-filter'
import { useSearchStore } from '@/stores/search'
import CheckboxFilter from '@/components/search/checkbox-filter.vue'
import FilterGrouping from '@/components/search/filter-grouping.vue'
import FilterGroupingsExpandToggle from '@/components/search/filter-groupings-expand-toggle.vue'

/** STATE **/
const route = useRoute()
const searchStore = useSearchStore()

/** NON REACTIVE **/
const isMyPrograms = route.name === 'MyProgramsBrowse'

// groupingIds and cacheKey use to persist expanded state to local storage
const groupingIds = {
  scheduleFilterGroup: 'scheduleFilterGroup',
  fbCollectionFilterGroup: 'fbCollectionFilterGroup',
  pickTimeFilterGroup: 'pickTimeFilterGroup',
  specialtyProgramsFilterGroup: 'specialtyProgramsFilterGroup',
  difficultyFilterGroup: 'difficultyFilterGroup',
}

// local storage cache key for which filters are expanded
const cacheKey = 'plan-browse-filter-groupings-expanded-v1'

/** EMITS **/
const emit = defineEmits(['filter-update'])

/** COMPOSABLES **/
const { checkboxFilters, triggerFiltering, initFilterGroupingsExpandedCache } = useSearchFilter({
  emit,
})

/** LIFECYCLE **/
onBeforeMount(() => {
  // init expanded state from local storage
  initFilterGroupingsExpandedCache({ cacheKey, groupingIds })
})
</script>
